import { useContext, useMemo } from "react";
import { SofaClient } from "@oai/sofa-client";

import { useGlobalContext } from "@/hooks/useGlobalContext";
import { APIUrlContext } from "@/lib/apiUrlContext";
import { PUBLIC_SOFA_BACKEND_URL } from "@/lib/constants";
import { createSofaClient } from "@/lib/sofaClient";

export type SofaRequestAuth = {
  accessToken: string;
  adAccountId: string;
};

export default function useSofaClient(): SofaClient {
  const ssrApiUrl = useContext(APIUrlContext);
  const apiUrl = ssrApiUrl || PUBLIC_SOFA_BACKEND_URL;
  const client = useMemo(() => createSofaClient(apiUrl), [apiUrl]);
  return client;
}
export { createSofaClient } from "@/lib/sofaClient";

export function useSofaAuth(): SofaRequestAuth {
  const { adAccountId, user } = useGlobalContext();
  if (!user) {
    throw new Error("useSofaAuth must be used within a GlobalContext with a user");
  }
  if (!adAccountId) {
    throw new Error("useSofaAuth must be used within a GlobalContext with an adAccountId");
  }
  return useMemo(
    () => ({ accessToken: user.accessToken, adAccountId }),
    [user.accessToken, adAccountId],
  );
}

export function getAuthHeaders(auth: SofaRequestAuth): { [key: string]: string } {
  return {
    "authorization": `Bearer ${auth.accessToken}`,
    "OpenAI-Ad-Account": auth.adAccountId,
  };
}
